import styled, { css } from 'styled-components';
export const Grid = styled.div `
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(4, 1fr);

  margin: 0 8px;

  background: repeating-linear-gradient(
    -45deg,
    var(--color-disabled) 2px 4px,
    var(--color-background) 4px 10.5px
  ) !important;

  ${({ view }) => view === 'day' &&
    css `
      grid-template-columns: repeat(7, minmax(32px, 1fr));
      grid-template-rows: repeat(5, 1fr);
    `}
`;
